import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const ModalContentContainer = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: "800px",
  borderRadius: 10,
});

export const ModalContentContainerWidthUnlimited = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  borderRadius: 10,
});
